import React, { useEffect, useState } from "react"
import { Modal, Table } from "react-bootstrap"
import { getRankedCandidates } from "../app/functions"

function ResultModal({ showResultModal, handleClose, handleCandidateClick }) {
  const [submissionsRanking, setSubmissionsRanking] = useState([])
  const [loading, setLoading] = useState(false)
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" })

  useEffect(() => {
    const getRanking = async () => {
      setLoading(true)
      let ranking = await getRankedCandidates()
      setSubmissionsRanking(ranking)
      setLoading(false)
    }
    if (showResultModal) {
      getRanking()
    }
  }, [showResultModal])

  const handleSort = (key) => {
    let direction = "asc"
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc"
    }
    setSortConfig({ key, direction })

    const sortedData = [...submissionsRanking].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1
      return 0
    })
    setSubmissionsRanking(sortedData)
  }

  return (
    <Modal show={showResultModal} centered onHide={handleClose} size="lg">
      <Modal.Title className="justify-center flex flex-col items-center p-4 pb-0 ">
        <div className="mb-2">Ranking</div>
      </Modal.Title>
      <Modal.Body className="justify-center flex flex-col items-center p-4 ">
        {loading && submissionsRanking.length !== 0 ? (
          <div>Ładowanie rankingu...</div>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Miejsce</th>
                <th>Imię Kandydata</th>
                <th
                  onClick={() => handleSort("averageRating")}
                  style={{ cursor: "pointer" }}
                >
                  Średnia ocen
                </th>
                <th
                  onClick={() => handleSort("totalRatingNums")}
                  style={{ cursor: "pointer" }}
                >
                  Ilość ocen
                </th>
                <th
                  onClick={() => handleSort("totalRating")}
                  style={{ cursor: "pointer" }}
                >
                  Suma ocen
                </th>
              </tr>
            </thead>
            <tbody>
              {submissionsRanking.map((candidate, index) => (
                <tr
                  key={candidate.candidateId}
                  onClick={() => handleCandidateClick(candidate)}
                >
                  <td>{index + 1}</td>
                  <td>
                    {candidate.name}&nbsp;{candidate.surname}
                  </td>
                  <td>{candidate.averageRating.toFixed(2)}</td>
                  <td>{candidate.totalRatingNums}</td>
                  <td>{candidate.totalRating}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ResultModal
